import { Link } from "react-router-dom";
import { siteConfig } from "../config/site";
import { buildGeneralWhatsAppUrl } from "../lib/whatsapp";
import { openCookieSettings } from "../lib/google-ads";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <div className="brand footer-brand">
            <img
              className="brand-logo"
              src="/images/rp-logo.png"
              alt=""
              width="48"
              height="48"
              aria-hidden="true"
            />
            <span>{siteConfig.brandName}</span>
          </div>
          <p>Royal Path · Independent booking agent for race-weekend ticket resale.</p>
          <p>{siteConfig.ticketPriceDisclosure}</p>
        </div>
        <div>
          <h2>Explore</h2>
          <Link to="/tickets">Tickets</Link>
          <Link to="/#event-info">Event info</Link>
          <Link to="/#faq">FAQ</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div>
          <h2>Policies</h2>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/refund-policy">Refund policy</Link>
          <button className="cookie-settings" type="button" onClick={openCookieSettings}>Cookie settings</button>
        </div>
        <div>
          <h2>Support</h2>
          <a data-whatsapp-location="footer" href={buildGeneralWhatsAppUrl("Race-weekend package enquiry")} target="_blank" rel="noreferrer">WhatsApp enquiries</a>
          <span>{siteConfig.supportEmail}</span>
          <span>{siteConfig.companyName}</span>
        </div>
      </div>
      <div className="container footer-bottom">
        <p>{siteConfig.legalDisclaimer}</p>
        <p>© {new Date().getFullYear()} {siteConfig.brandName}</p>
      </div>
    </footer>
  );
}
